<template>
	<section class="marketing-section bg-color-greige">
		<div class="container">
			<InfoCardSingular
				:card="infoCard"
				card-heading-style="heading-1"
				:use-button-link="true"
				:use-full-img-url="true"
			/>
		</div>
	</section>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { InfoCard } from 'types/layout';
import InfoCardSingular from '@components/layout/info-card-singular.vue';
import { SanityInfoCard } from 'types/sanity/marketing-components';
interface Props {
	card: SanityInfoCard;
}
const props = defineProps<Props>();

const infoCard = computed((): InfoCard => {
	return {
		heading: props.card.heading ?? undefined,
		title: props.card.title,
		description: [props.card.description],
		imageUrl: props.card.image?.asset.url ?? '',
		link: {
			text: props.card.link?.linkText ?? undefined,
			href: props.card.link?.url ?? undefined
		}
	};
});
</script>
